import { Vue } from 'vue-property-decorator';
import { PublicApi } from '@/api/PublicApi';
import ApiUtils from '@/api/util/ApiUtils';

export default class BaseVue extends Vue {
    protected api: PublicApi | null = null;
    protected busy: boolean = false;

    constructor() {
        super();
        if (ApiUtils.hasValue(ApiUtils.getValue(window, '__env'))) {
            const apiKey = ApiUtils.getValue(window, '__env.api');
            this.$store.commit('api', apiKey);
            this.$store.commit('google', ApiUtils.getValue(window, '__env.googleApiKey'));
            this.$store.commit('sdkConfig', ApiUtils.getValue(window, '__env.sdkConfig'));
            this.$store.commit('recaptchaKey', ApiUtils.getValue(window, '__env.recaptchaInvisibleKey'));
            this.api = new PublicApi(apiKey);

            const embedConfig = {
                scriptUrl: ApiUtils.getValue(window, '__env.embedScriptUrl'),
                givingFormScriptUrl: ApiUtils.getValue(window, '__env.givingFormScriptUrl'),
            };
            this.$store.commit('configureEmbed', embedConfig);
        } else if (ApiUtils.hasValue(this.$store.getters.api)) {
            this.api = new PublicApi(this.$store.getters.api);
        }
    }

    protected handleSuccessIgnoreError(res: any, objPath: string) {
        const errors = ApiUtils.getValue(res, 'errors');
        if (errors && errors.length > 0) {
          // tslint:disable-next-line: no-console
          console.error('Ignored load errors\n: ' + JSON.stringify(errors));
        }
        return (objPath !== '') ? ApiUtils.getValue(res, objPath) : null;
    }


    protected handleSuccess(res: any, objPath: string, errorPath: string = 'errors') {
        const errors = ApiUtils.getValue(res, errorPath);
        const gqlErrors = errorPath === 'errors' ? null : ApiUtils.getValue(res, 'errors');
        if (errors && errors.length > 0) {
            this.$msgbox(this.errorsToString(errors), 'Error');
        } else if (gqlErrors && gqlErrors.length > 0) {
            this.$msgbox(this.errorsToString(gqlErrors), 'System Error');
        }

        return (objPath !== '') ? ApiUtils.getValue(res, objPath) : null;
    }

    protected handleFailure(errors) {
        if (this !== undefined) {
            this.busy = false;
            if (ApiUtils.hasValue(errors)) {
                this.$msgbox(this.errorsToString(errors), 'Errors');
            }
        }
    }

    protected handleMessage(res: any) {
        const errors = ApiUtils.getValue(res, 'errors');
        if (errors && errors.length > 0) {
            this.$msgbox(this.errorsToString(errors), 'System Errors');
        }
    }

    protected errorsToString(errors: any) {
        let strError = '';
        if (Array.isArray(errors)) {
            for (const error of errors) {
                strError += ((typeof error) === 'string') ? error + '\n' : JSON.stringify(error) + '\n';
            }
        } else if (errors instanceof Error) {
            strError = errors.message;
        } else {
            strError = errors;
        }
        return strError;
    }
}
